import React from 'react';

import { StyledAccordion } from './Accordion.styles';
import type { AccordionProps } from './Accordion.types';

/**
 * Primitive Accordion component with container query support
 * Provides a responsive accordion with theme-integrated styling
 */
export const Accordion: React.FC<AccordionProps> = ({ children, ...props }) => {
  // containerName is handled via CSS, not as a prop
  return <StyledAccordion {...props}>{children}</StyledAccordion>;
};